import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  EVENTS_FEATURE_KEY,
  State,
  EventsPartialState,
  eventsAdapter,
} from './events.reducer';

// Lookup the 'Events' feature state managed by NgRx
export const getEventsState = createFeatureSelector< State>(
  EVENTS_FEATURE_KEY
);

const { selectAll, selectEntities } = eventsAdapter.getSelectors();

export const getEventsLoaded = createSelector(
  getEventsState,
  (state: State) => state.loaded
);

export const getEventsError = createSelector(
  getEventsState,
  (state: State) => state.error
);

export const getAllEvents = createSelector(getEventsState, (state: State) =>
  selectAll(state)
);

export const getEventsEntities = createSelector(
  getEventsState,
  (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getEventsState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getEventsEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);
